import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  desc: {
    marginTop: '0.3rem',
    maxWidth: 700,
  },
  publishModal: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    gap: '1rem',
    '& .subTitle': {
      marginTop: theme.spacing(1),
    },
    '& .actionButton': {
      '& button': {
        marginRight: theme.spacing(2),
      },
    },
    '& .publishImage': {
      background: 'black',
      height: 263,
      width: '100%',
      borderRadius: '0.4rem',
      overflow: 'hidden',
      aspectRatio: 16 / 9,
      '&>img': {
        width: 'calc(100% + 16px)',
        position: 'relative',
        top: -4,
        left: -8,
        display: 'block',
      },
    },
  },
  commingSoon: {
    marginTop: theme.spacing(3),
    borderRadius: '1rem',
    background: theme.palette.primary.main,
    padding: '1.5rem',
    display: 'flex',
    color: theme.palette.primary.contrastText,
    '& h2': {
      fontSize: 28,
    },
    '& p': {
      marginTop: theme.spacing(1),
      maxWidth: '70%',
    },
    '& button': {
      marginTop: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      color: theme.palette.primary.main,
      paddingRight: theme.spacing(2),
      background: theme.palette.primary.contrastText,
      '& svg': {
        fill: theme.palette.primary.main,
      },
      '&:hover': {
        background: theme.palette.primary.contrastText,
      },
    },
  },
  dlpSmallBanner: {
    background: 'linear-gradient(90deg, #DEE762 0%, #E0E965 100%)',
    borderRadius: '0.3rem',
    marginTop: '1rem',
    position: 'relative',

    '& .block': {
      padding: '0.6rem 1rem',
      display: 'flex',
      position: 'relative',
      zIndex: 2,
      alignItems: 'center',
      justifyContent: 'space-between',
      '& label': {
        fontWeight: 500,
      },
      '& svg': {
        fill: '#848B28',
        height: 20,
        width: 20,
      },
      '& button': {
        background: '#fff',
        color: '#848B28',
        borderRadius: '0.4rem',
        fontWeight: 500,
        minWidth: 140,
        '&:hover': {
          background: '#fff',
        },
      },
    },
  },
  lpActions: {
    background: theme.palette.bg.white,
    minWidth: 180,
    boxShadow: '0px 3px 6px #0000001A',
  },
  newCard: {
    padding: '1rem',
    display: 'flex',
    height: '100%',
    gap: '1rem',
    alignItems: 'flex-start',
    position: 'relative',
    '&.leftBlock': {
      '& .imgBlock': {
        background: 'linear-gradient(76.99deg, #FFE9E7 6.65%, #D4E1F9 77.16%)',
        padding: '1rem',
        '&>img': {
          aspectRatio: 16 / 9,
          border: '3px solid #000',
          borderRadius: '10px',
        },
      },
    },
    '&.publishCard': {
      background: '#fdf1f1',
      border: `1px solid ${theme.palette.primary.main}`,
    },
    '& .published': {
      position: 'absolute',
      borderRadius: '0.3rem',
      top: 8,
      left: 8,
      background: '#6CB851',
      color: '#fff',
      '& svg': {
        marginLeft: theme.spacing(1),
        height: 14,
        width: 14,
      },
    },
    '& .preview-action': {
      display: 'flex',
      position: 'absolute',
      top: '10px',
      right: '10px',
      gap: '0.5rem',
      '& .iconAction': {
        height: '1.5rem',
        background: '#F6F8F8',
        borderRadius: '0.3rem',
        width: '1.5rem',
      },
    },
    '& .planImageBg': {
      background: '#9B87F5',
      borderRadius: 12,
      height: 150,
      width: '50%',
      minWidth: '50%',
      aspectRatio: 16 / 9,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      '& .loogo': {
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& .tag': {
        background: '#fff',
        color: '#9B87F5',
        position: 'absolute',
        left: '10px',
        top: '10px',

        fontWeight: 400,
        fontSize: '14px',
        padding: '2px 24px',
        borderRadius: '7px',
      },
    },
    '&.canvasWrap': {
      background: '#f8f6ff',
      border: '1px solid #9B87F5',
    },
    '& .canvasAction': {
      background: '#000',
      minWidth: 145,
      color: '#fff',
      width: 'auto',
    },
    '& .imgBlock': {
      height: 150,
      width: '50%',
      position: 'relative',
      minWidth: '50%',
      borderRadius: '0.75rem',
      background: '#000',
      overflow: 'hidden',
      aspectRatio: 16 / 9,
      '& img': {
        width: 'calc(100% + 8px)',
        display: 'block',
        position: 'relative',
        left: -4,
        top: -3,
      },
    },
    '& .wrapper': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'space-between',
      '& .pageDesc': {
        marginTop: '0.5rem',
        '& a': {
          color: theme.palette.primary.main,
          cursor: 'pointer',
        },
      },
    },
    '& .action': {
      display: 'flex',
      gap: '0.5rem',
      alignItems: 'center',
      '& button': {
        border: `1px solid ${theme.palette.bg.whiteOff2}`,
        minWidth: 105,
        background: '#fff',
        '& .MuiButton-endIcon ': {
          marginRight: 0,
          marginLeft: 6,
        },
      },
    },
  },
  tpName: {
    marginTop: '0.6rem',
    textTransform: 'capitalize',
  },
  template: {
    '&:hover': {
      '&>.action': {
        opacity: 1,
      },
    },
    width: '100%',
    height: 180,
    '& img': {
      width: '100%',
      height: '100%',
      display: 'block',
    },
    overflow: 'hidden',
    position: 'relative',
    '& .action': {
      transition: 'opacity 0.3s',
      position: 'absolute',
      opacity: 0,
      gap: '1rem',
      flexDirection: 'column',
      top: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
      '& button': {
        minWidth: 180,
      },
    },
  },
  breadCrumbsBlock: {
    '& li': {
      display: 'flex',
    },
    '& a': {
      color: theme.palette.primary.light,
      fontWeight: 500,
      fontSize: '14px',
    },
  },
  newDLPBlock: {
    '& .desc': {
      marginTop: '0.5rem',
      maxWidth: 700,
      marginBottom: '2rem',
    },
  },
  recent: {
    marginTop: '1rem',
    borderRadius: '0.5rem',
    padding: '1rem',
    display: 'flex',
    alignItems: 'flex-start',

    justifyContent: 'space-between',
    '& .action': {
      display: 'flex',
      gap: '0.5rem',
      alignItems: 'center',
      marginTop: '0.6rem',
      '& button': {
        border: `1px solid ${theme.palette.bg.whiteOff2}`,
        minWidth: 105,
        background: '#fff',
        '& .MuiButton-endIcon ': {
          marginRight: 0,
          marginLeft: 6,
        },
      },
    },
    '& .wrapper': {
      display: 'flex',
      gap: '1.5rem',
      '& .pageDesc': {
        marginTop: '0.3rem',
        '& a': {
          color: theme.palette.primary.main,
          cursor: 'pointer',
        },
      },
    },
    '& .imgBlock': {
      height: 88,
      '&.publishedIg': {
        height: 102,
      },
      // borderRadius: '0.5rem',
      background: '#000',
      overflow: 'hidden',
      aspectRatio: 16 / 9,
      position: 'relative',
      borderRadius: '0.7rem',
      '& .draftChip': {
        position: 'absolute',
        borderRadius: '0.3rem',
        top: 8,
        left: 8,
      },
      '& .published': {
        position: 'absolute',
        borderRadius: '0.3rem',
        top: 8,
        left: 8,
        background: '#6CB851',
        color: '#fff',
        '& svg': {
          marginLeft: theme.spacing(1),
          height: 14,
          width: 14,
        },
      },
      '& img': {
        borderRadius: '0.7rem',
        width: 'calc(100% + 6px)',
        position: 'relative',
        left: -3,
        top: -2,
        display: 'block',
        objectFit: 'cover',
      },
    },
    '& .preview-action': {
      display: 'flex',
      gap: '0.5rem',
      '& .iconAction': {
        height: '2.2rem',
        background: '#F6F8F8',
        borderRadius: '0.3rem',
        width: '2.2rem',
      },
    },
  },
  desktopStripe: {
    background: '#131313',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    '&.desktop': {
      width: 'calc(100% - 200px)',
    },
    '&.tablet': {
      width: 760,
    },
    '&.phone': {
      width: 380,
    },
    margin: '30px auto 0',
    '& .dot': {
      height: '9px',
      width: '9px',
      borderRadius: '50%',
      background: '#FFBC00',
      '&:nth-child(n+2)': {
        marginLeft: theme.spacing(1),
      },
      '&:first-child': {
        background: ' #F45952',
      },
      '&:last-child': {
        background: '#0CD651',
      },
    },
  },
  previewDLP: {
    position: 'fixed',
    top: 0,
    zIndex: 111,
    left: 0,
    height: '100vh',
    width: '100%',
    background: '#fff',
    '& .preview': {
      '&.desktop': {
        width: 'calc(100% - 200px)',
      },
      '&.tablet': {
        width: 760,
      },
      '&.phone': {
        width: 380,
      },
      margin: '0px auto',
      overflowY: 'auto',
      overflowX: 'hidden',
      maxHeight: 'calc(100vh - 120px)',
      minHeight: 'calc(100vh - 120px)',
      height: 'calc(100vh - 120px)',
      '& .previewDesk': {
        '&.imagePreview': {
          maxHeight: '100%',
        },
        '@media screen and (min-width: 1600px)': {
          maxHeight: '40rem',
        },
        '& iframe': {
          border: 'none',
        },
        '&>img': {
          width: '100%',
          maxHeight: '100%',
          display: 'block',
        },
      },
    },
    '& header': {
      display: 'flex',
      padding: `${theme.spacing(0.7)}px ${theme.spacing(2)}px`,
      minHeight: 59,
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: `1px solid ${theme.palette.bg.whiteOff2}`,
      '& .left': {
        gap: '0.5rem',
      },
      '& .middle': {
        gap: '0.3rem',

        '& button': {
          padding: theme.spacing(1),
        },
      },
    },
  },
  modalAction: {
    gap: '1rem',
  },
  modalWrapper: {
    gap: '2rem',
  },
  modalPreview: {
    height: 263,
    width: '100%',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      display: 'block',
      height: 'auto',
    },
  },
  label: {
    marginBottom: '0.2rem',
    display: 'inline-flex',
  },
  heading: {
    padding: '1.2rem',
    borderBottom: `1px solid ${theme.palette.bg.whiteOff2}`,
  },
}));
